/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useMemo } from "react";
import { Group, Resource } from "~/generated/graphql";
import { useDuplicatedResources } from "~/hooks/useDuplicatedResources";
import { ResourceList } from "./ResourceList";

type Props = {
  resourceGroups: Group[];
  resources: Resource[];
};

export function PlanResourcesSection({ resourceGroups, resources }: Props) {
  const duplicateState = useDuplicatedResources({
    resourceCollections: [resources],
    actionChangeKey: useMemo(
      () => resourceGroups.map((group) => group.id).join(","),
      [resourceGroups]
    ),
  });

  return (
    <ResourceList
      resourceGroups={resourceGroups}
      resources={resources}
      duplicateState={duplicateState}
    />
  );
}
